import type { DocPageContent } from '../docs-content'

const page = {
  order: 23,
  slug: 'reference',
  title: 'Referencia',
  description: 'Formatos compatibles y un glosario de los términos utilizados en esta guía.',
  category: 'Referencia',
  related: ['concepts', 'keyboard-shortcuts'],
  sections: [
    {
      title: 'Formatos',
      blocks: [
        {
          kind: 'table',
          headers: ['Uso', 'Tipos'],
          rows: [
            ['Importación', 'Vídeo, audio, imagen, GIF, SVG, activos generados, clips compuestos'],
            ['Exportación de vídeo', 'MP4, MOV, WebM, MKV'],
            ['Exportación de audio', 'MP3, AAC, WAV'],
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          text: 'La compatibilidad con códecs depende de lo que tu sistema pueda decodificar y codificar.',
        },
      ],
    },
    {
      title: 'Términos de edición',
      blocks: [
        {
          kind: 'table',
          headers: ['Término', 'Significado'],
          rows: [
            ['Rango de entrada/salida', 'Un inicio y fin marcados que se utilizan para ediciones de origen y rangos de exportación.'],
            ['Material de origen', 'Fotogramas sobrantes más allá de un borde de clip, necesarios para recortes y transiciones.'],
            ['Edición con ripple', 'Una edición que desplaza el material posterior para abrir o cerrar espacio en la línea de tiempo.'],
            ['Edición rolling', 'Una edición que mueve el corte entre dos clips vecinos.'],
            ['Edición slip', 'Cambia los fotogramas fuente dentro de un clip sin mover el clip.'],
            ['Edición slide', 'Mueve un clip mientras ajusta los cortes vecinos.'],
          ],
        },
      ],
    },
    {
      title: 'Términos de funciones',
      blocks: [
        {
          kind: 'table',
          headers: ['Término', 'Significado'],
          rows: [
            ['Espacio de trabajo', 'La carpeta desde la que CachoCut lee y escribe.'],
            ['Proxy', 'Una copia generada más ligera de medios pesados utilizada para una reproducción más fluida.'],
            ['Clip compuesto', 'Una sección de la línea de tiempo agrupada en un único elemento de medios reutilizable.'],
            ['Capa de ajuste', 'Una capa cuyos efectos y graduación se aplican a los clips que tiene debajo.'],
            ['Fotograma clave', 'Un valor establecido en un momento específico para animar una propiedad.'],
            ['LUT', 'Una tabla de búsqueda (.cube) que aplica una transformación de color.'],
            ['Destino de parche', 'La pista de la línea de tiempo a la que se envía una edición del monitor de origen.'],
            ['Cola de renderizado', 'Una lista ordenada de exportaciones que se renderizan una a la vez.'],
            ['Pre-vuelo', 'La comprobación de disponibilidad que se ejecuta antes de que comience una exportación.'],
          ],
        },
      ],
    },
  ],
} satisfies DocPageContent

export default page